<button class="button " 
  [attr.dpad]="dpad"
  [style.--scale-dpad]="scaledpad"
  [attr.x-dpad]="xdpad" 
  [attr.y-dpad]="ydpad" 
  (click)="clickHandler()" 
  (mouseover)="onMouseOver()"
  (mouseout)="onMouseOut()"
  [disabled]="disabled" 
  [ngClass]="[buttonType, iconType ? 'button-icon': '' , cssCustom ? 'web-mode-focus' : '']"
  [ngStyle]="buttonStyle">
  <i *ngIf="iconType" class="pi " [ngClass]="iconType"></i>
  <pre>{{buttonText}}</pre>
</button>